import $ from 'jquery'

export default telAnchor => {
  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
    $(function () {
      $('.tel').each(function () {
        var $this = $(this)
        var str = $this.html()
        $this.html($('<a>').attr('href', 'tel:' + $this.text().replace(/-/g, '')).addClass('c-link-underline').append(str + '</a>'))
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/access.js